import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {ChannelExternalTypesEnum} from '../../models/api/channelBehaviorsModel';
import {ChannelTypesEnum} from '../../models/api/channelCommonTypes';
import {ChannelIcon, ChannelIconSizesEnum} from './channelIcon';

/*
 * Constants.
 */

const applicationImgSizes: {[key in ChannelIconSizesEnum]: number} = {
  [ChannelIconSizesEnum.SMALL]: 16,
  [ChannelIconSizesEnum.REGULAR]: 20,
  [ChannelIconSizesEnum.BIG]: 40,
};

const applicationIconSizes: {[key in ChannelIconSizesEnum]: number} = {
  [ChannelIconSizesEnum.SMALL]: 12,
  [ChannelIconSizesEnum.REGULAR]: 14,
  [ChannelIconSizesEnum.BIG]: 28,
};

/*
 * Props.
 */

interface ChannelIconOrImageProps {
  className?: string;
  size?: ChannelIconSizesEnum;
  type?: ChannelTypesEnum | ChannelExternalTypesEnum;
  imgSrc?: string;
  iconSize?: number;
}

/*
 * Style.
 */

interface ApplicationImageSizeProps {
  $size: number;
}

const StyledApplicationImg = styled.img<ApplicationImageSizeProps>`
  ${(p) => css`
    width: ${p.$size}px;
    height: ${p.$size}px;
  `};
  border-radius: 9000px;
`;

const StyledApplicationIconWrapperDiv = styled.div<ApplicationImageSizeProps>`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  background: ${(p) => p.theme.greys.shade40};
  border-radius: 9000px;
  ${(p) => css`
    width: ${p.$size}px;
    height: ${p.$size}px;
  `};
`;

const StyledIcon = styled(Icon)`
  margin: auto;
  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const ChannelIconOrImage: FC<ChannelIconOrImageProps> = (props) => {
  const {className, imgSrc, type, size = ChannelIconSizesEnum.REGULAR, iconSize} = props;

  if (type) {
    return <ChannelIcon className={className} size={size} type={type} />;
  }
  if (imgSrc) {
    return <StyledApplicationImg className={className} src={imgSrc} $size={applicationImgSizes[size]} />;
  }
  return (
    <StyledApplicationIconWrapperDiv className={className} $size={applicationImgSizes[size]}>
      <StyledIcon name="integrationsFilledSmall" size={iconSize || applicationIconSizes[size]} />
    </StyledApplicationIconWrapperDiv>
  );
};
